export const SET_LEADS_LIST: string = 'boomerang/SET_LEADS_LIST';
export const SELECT_LEAD: string = 'boomerang/SELECT_LEAD';
export const RESET_STATE: string = 'boomerang/RESET_STATE';
export const ASSIGN_LEAD: string = 'boomerang/ASSIGN_LEAD';
export const ADD_TOP_INTEREST: string = 'boomerang/ADD_TOP_INTEREST';
export const UPDATE_DEAL_STATUS: string = 'boomerang/UPDATE_DEAL_STATUS';
export const SET_NUM_LEADS: string = 'boomerang/SET_NUM_LEADS';
export const FETCH_LEADS: string = 'boomerang/FETCH_LEADS';
export const PAGE_HAS_UPDATE: string = 'boomerang/PAGE_HAS_UPDATE';
export const REFRESH_LEADS: string = 'boomerang/REFRESH_LEADS';
export const FETCHING_INTERESTS: string = 'boomerang/FETCHING_INTERESTS';
export const SET_ASSIGNMENT_OPTIONS: string = 'boomerang/SET_ASSIGNMENT_OPTIONS';
export const UPDATE_SELECTED_LEAD: string = 'boomerang/UPDATE_SELECTED_LEAD';
export const UPDATE_LEADS_TOTALS: string = 'boomerang/UPDATE_LEADS_TOTALS';
export const SET_NOTES: string = 'boomerang/SET_NOTES';
export const ADD_NOTE: string = 'boomerang/ADD_NOTE';
